//
// locale_ast.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ast.json';
import localeData from "react-intl/locale-data/ast.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
